var map = {
	"./ion-action-sheet.entry.js": [
		"ZhjL",
		0,
		16
	],
	"./ion-alert.entry.js": [
		"8Gwc",
		0,
		17
	],
	"./ion-app_8.entry.js": [
		"whX3",
		0,
		18
	],
	"./ion-avatar_3.entry.js": [
		"zxKL",
		0,
		19
	],
	"./ion-back-button.entry.js": [
		"SzUi",
		0,
		20
	],
	"./ion-backdrop.entry.js": [
		"Qp3K",
		21
	],
	"./ion-button_2.entry.js": [
		"RFME",
		0,
		22
	],
	"./ion-card_5.entry.js": [
		"Bwsr",
		0,
		23
	],
	"./ion-checkbox.entry.js": [
		"39hh",
		0,
		24
	],
	"./ion-chip.entry.js": [
		"Qw1i",
		0,
		25
	],
	"./ion-col_3.entry.js": [
		"aoqT",
		26
	],
	"./ion-datetime_3.entry.js": [
		"wVt7",
		0,
		27
	],
	"./ion-fab_3.entry.js": [
		"3UdO",
		0,
		28
	],
	"./ion-img.entry.js": [
		"lYhy",
		29
	],
	"./ion-infinite-scroll_2.entry.js": [
		"0eXd",
		30
	],
	"./ion-input.entry.js": [
		"0REi",
		0,
		31
	],
	"./ion-item-option_3.entry.js": [
		"G7PU",
		0,
		32
	],
	"./ion-item_8.entry.js": [
		"adrD",
		0,
		33
	],
	"./ion-loading.entry.js": [
		"U6VO",
		0,
		34
	],
	"./ion-menu_3.entry.js": [
		"ywCJ",
		0,
		35
	],
	"./ion-modal.entry.js": [
		"GtCq",
		0,
		36
	],
	"./ion-nav_2.entry.js": [
		"5E8l",
		0,
		37
	],
	"./ion-popover.entry.js": [
		"QoXI",
		0,
		38
	],
	"./ion-progress-bar.entry.js": [
		"m3Jx",
		0,
		39
	],
	"./ion-radio_2.entry.js": [
		"vrNu",
		0,
		40
	],
	"./ion-range.entry.js": [
		"cZ/H",
		0,
		41
	],
	"./ion-refresher_2.entry.js": [
		"Ckc3",
		0,
		42
	],
	"./ion-reorder_2.entry.js": [
		"ZnLq",
		0,
		43
	],
	"./ion-ripple-effect.entry.js": [
		"yNr1",
		44
	],
	"./ion-route_4.entry.js": [
		"EOjV",
		0,
		45
	],
	"./ion-searchbar.entry.js": [
		"hiXc",
		0,
		46
	],
	"./ion-segment_2.entry.js": [
		"DAJM",
		0,
		47
	],
	"./ion-select_3.entry.js": [
		"0l/T",
		0,
		48
	],
	"./ion-slide_2.entry.js": [
		"Bd2z",
		49
	],
	"./ion-spinner.entry.js": [
		"4RuT",
		0,
		50
	],
	"./ion-split-pane.entry.js": [
		"quii",
		51
	],
	"./ion-tab-bar_2.entry.js": [
		"oru3",
		0,
		52
	],
	"./ion-tab_2.entry.js": [
		"ZyW4",
		0,
		53
	],
	"./ion-text.entry.js": [
		"7Ttm",
		0,
		54
	],
	"./ion-textarea.entry.js": [
		"h5gs",
		0,
		55
	],
	"./ion-toast.entry.js": [
		"waU6",
		0,
		56
	],
	"./ion-toggle.entry.js": [
		"vvI+",
		0,
		57
	],
	"./ion-virtual-scroll.entry.js": [
		"X9e5",
		58
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Bf66";
module.exports = webpackAsyncContext;